<template>
  <div @click="toggleShow" class="fast-bids-toggle-show" :class="{ active: state.isShow }"></div>
  <div @click="toggleShow" class="fast-bids-toggle-show-mob" :class="{ active: state.isShow }">{{ state.isShow ? "Hide buttons" : "More buttons"}}</div>
</template>

<script lang="ts" setup>
  import { onMounted, reactive } from "vue";

  const props = withDefaults(
    defineProps<{
      target: string;
      wrapperClass?: string | null;
    }>(),
    {
      wrapperClass: ""
    }
  );

  const state = reactive({
    isShow: false
  });

  const toggleShow = () => {
    state.isShow = !state.isShow;
    const elements = document.querySelectorAll<HTMLElement>(props.target);

    if (elements) {
      elements.forEach((element) => {
        if (state.isShow) {
          element.classList.add("active");
        } else {
          element.classList.remove("active");
        }
      });
    }

    if (props.wrapperClass) {
      const wrapperNode = document.querySelector<HTMLElement>(props.wrapperClass);

      if (wrapperNode) {
        if (state.isShow) {
          wrapperNode.classList.add("show-fast-bid-buttons");
        } else {
          wrapperNode.classList.remove("show-fast-bid-buttons");
        }
      }
    }
  };
</script>

<style scoped></style>
